import { queryOptions } from '@tanstack/react-query';
import { mutationOptions } from '../../common/utils';
import { orderAPIClient } from '../orderAPIClient';
import { ORDER_QUERY_KEYS } from './keys';
import type {
  GetOrderRequest,
  GetOrdersRequest,
  GetUserOrdersRequest,
  AssociateOrderRequest,
  AssociateOrderResponse,
} from './types';

export const ORDER_QUERIES = {
  getOrder: (params: GetOrderRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getOrder(params),
      queryFn: () => orderAPIClient.getOrder(params),
      enabled: !!params.orderId,
      retry: false,
    });
  },

  getOrders: (params?: GetOrdersRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getOrders(params),
      queryFn: () => orderAPIClient.getOrders(params),
    });
  },

  getUserOrders: (params: GetUserOrdersRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getUserOrders(params),
      queryFn: () => orderAPIClient.getUserOrders(params),
      enabled: !!params.userId,
      retry: false,
    });
  },

  associateOrder: () =>
    mutationOptions<AssociateOrderResponse, unknown, AssociateOrderRequest>({
      mutationKey: ORDER_QUERY_KEYS.associateOrder(),
      mutationFn: (payload) => orderAPIClient.associateOrder(payload),
    }),
};
